var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconIslikeTemplate = function SvgIconIslikeTemplate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DA613A",
    d: "M9.833 4.345a4.73 4.73 0 0 0-6.772 0 4.91 4.91 0 0 0 0 6.857l5.75 5.859a1.667 1.667 0 0 0 2.379 0l5.749-5.86a4.91 4.91 0 0 0 0-6.856 4.73 4.73 0 0 0-6.773 0 .233.233 0 0 1-.333 0"
  })));
};
export default SvgIconIslikeTemplate;